import React from "react"
import {Route, Routes} from "react-router-dom"
import {ErrorPage} from "../pages/error/ErrorPage"

type Props = {
    children: React.ReactElement | React.ReactElement[]
}

export function ErrorBoundaryRoutes({children}: Props) {
    return (<Routes>
            {children}
            <Route path="*" element={<ErrorPage/>}/>
        </Routes>)
}